export default __webpack_public_path__ + "static/sentrydefault_480x270-94f97fa9127f99dfd48c7dac6d40bcbe.webp";